import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * CardMenuActions Component - A reusable menu component specifically for cards
 * that displays a horizontal three-dot menu icon and renders children as menu items
 * 
 * @param {Object} props
 * @param {ReactNode} props.children - React elements to render as menu items
 */
const CardMenuActions = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls={open ? 'card-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="card-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'card-menu-button',
        }}
      >
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            // Provide a callback so children (e.g., Approve/Reject) can close the menu AFTER async success
            closeParentMenu: handleClose,
          })
        )}
      </Menu>
    </>
  );
};

export default CardMenuActions;
